import {
  IconCash,
  IconFileText,
  IconHistory,
  IconHistoryToggle,
  IconLayoutDashboard,
  IconPackage,
  IconReport,
  IconSubtask,
  IconUser,
  IconUserCheck
} from "@tabler/icons";

import { uniqueId } from "lodash";

const Menuitems = [
  {
    navlabel: true,
    subheader: "Home",
  },

  {
    id: uniqueId(),
    title: "Dashboard",
    icon: IconLayoutDashboard,
    href: "/admin",
  },
  {
    navlabel: true,
    subheader: "Management",
  },
  {
    id: uniqueId(),
    title: "Admins",
    icon: IconUserCheck,
    href: "/admin/permissions",
  },
  {
    id: uniqueId(),
    title: "Users",
    icon: IconUserCheck,
    href: "/admin/users",
  },
  {
    id: uniqueId(),
    title: "Products",
    icon: IconPackage,
    href: "/admin/products",
  },

  {
    id: uniqueId(),
    title: "Old Reports",
    icon: IconSubtask,
    href: "/admin/old-report",
  },
  {
    id: uniqueId(),
    title: "Reports",
    icon: IconSubtask,
    href: "/admin/report",
  },
  {
    navlabel: true,
    subheader: "Monitoring",
  },
  {
    id: uniqueId(),
    title: "Report History",
    icon: IconReport,
    href: "/admin/report-history",
  },
  {
    id: uniqueId(),
    title: "Products History",
    icon: IconHistoryToggle,
    href: "/admin/product-history",
  },
  {
    id: uniqueId(),
    title: "Leads",
    icon: IconHistory,
    href: "/admin/leads",
  },
  {
    id: uniqueId(),
    title: "Transactions",
    icon: IconCash,
    href: "/admin/transactions",
  },
  {
    id: uniqueId(),
    title: "File Jobs",
    icon: IconFileText,
    href: "/admin/file-jobs",
  },
  {
    navlabel: true,
    subheader: "Account",
  },
  {
    id: uniqueId(),
    title: "Profile",
    icon: IconUser,
    href: "/profile",
  },
];

export default Menuitems;
